import * as React from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { withRouter, RouteComponentProps } from 'react-router';
import { compose } from 'redux';
import { Drawer, Checkbox } from 'components/';
import { Query, QueryResult } from 'react-apollo';
import * as Queries from 'api/graphql/queries';
import { AdminPromotionCategoryList, OrderDirection, AdminPromotionCategoryList_adminPromotionCategories } from '@api/graphql/types';
import { RowInfo, SortingRule } from 'react-table';
import { Column } from 'react-virtualized';
import Paths from '../paths';
import { BooleanCell, OpenInNewCell } from '@components/Table/Cell';
import Colors from '@root/utils/Colors';
import ReduxTable from '@components/ReduxTable';

type Props = InjectedIntlProps & RouteComponentProps;

export const PromotionCategoryListDefaultOptions = {
    sortBy: {
        field: 'sort',
        direction: OrderDirection.ASC,
    },
    count: 10,
    page: 0,
    filters: {},
};

const listName = 'promotionCategoryList';

interface State {
    shouldFilterIsEnable: boolean;
}

class PromotionCategoryList extends React.Component<Props, State> {
    public state = {
        shouldFilterIsEnable: true,
    };

    private defaultSorted: SortingRule[] = [{id: 'id', desc: true}];

    private OpenCell = OpenInNewCell((rowInfo: any) => {
        return `${Paths.promotionCategory}/${rowInfo.original.id}`;
    });

    private tableColumns = [
        {Header: '', sortable: false, Cell: this.OpenCell, width: 30},
        this.getDefaultColumnByName('id'),
        this.getDefaultColumnByName('name'),
        this.getDefaultColumnByName('is_enable', {Cell: BooleanCell}),
        this.getDefaultColumnByName('promotion_place'),
        this.getDefaultColumnByName('date_from'),
        this.getDefaultColumnByName('date_to'),
    ];

    private getDefaultColumnByName(name: string, options: any = {}) {
        return {
            Header: this.label(`${name}.title`),
            accessor: name,
            sortable: true,
            ...options,
        };
    }

    private label(id: string): string {
        return this.props.intl.formatMessage({ id: `module.promotionCategory.${id}` });
    }

    private onRowClick(finalState: any, rowInfo?: RowInfo, column?: Column, instance?: any) {
        if (rowInfo) {
            return {
                onClick: () => {
                    this.props.history.push(`${Paths.promotionCategory}/${rowInfo.original.id}`);
                },
                style: {
                    cursor: 'pointer',
                    color: (rowInfo.original.is_enable ? '' : Colors.inactive),
                },
            };
        }
        return {};
    }

    private filterIsEnable = (adminPromotionCategories: AdminPromotionCategoryList_adminPromotionCategories[]): AdminPromotionCategoryList_adminPromotionCategories[] => {
        if (this.state.shouldFilterIsEnable) {
            return adminPromotionCategories.filter((category: AdminPromotionCategoryList_adminPromotionCategories) => category.is_enable);
        }
        return adminPromotionCategories;
    }

    private renderList(result: QueryResult<AdminPromotionCategoryList>) {
        if (result.loading) return null;
        if (result.error) return `Error!: ${result.error}`;

        if (result.data) {
            return (
                <ReduxTable
                    filterable={false}
                    listName={listName}
                    defaultOptions={PromotionCategoryListDefaultOptions}
                    data={this.filterIsEnable(result.data.adminPromotionCategories)}
                    columns={this.tableColumns}
                    defaultPageSize={10}
                    defaultSorted={this.defaultSorted}
                    className="-striped -highlight"
                    getTdProps={(finalState: any, rowInfo?: RowInfo, column?: Column, instance?: any) => this.onRowClick(finalState, rowInfo, column, instance)}
                />
            );
        }
        return null;
    }

    public render() {
        const addButton = <button className="btn btn-primary" onClick={(e: React.SyntheticEvent) => this.props.history.push(Paths.promotionCategoryCreate)}>{this.props.intl.formatMessage({id: 'module.promotionCategory.create.title'})}</button>;
        return (
            <Drawer headerButton={addButton}>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ibox float-e-margins">
                            <div className="ibox-content">
                                <Checkbox
                                    checked={this.state.shouldFilterIsEnable}
                                    label={this.props.intl.formatMessage({id: 'common.filterActive'})}
                                    onChange={(e: React.ChangeEvent<any>) => {
                                        this.setState({ shouldFilterIsEnable: e.currentTarget.checked });
                                    }}
                                />
                                <Query query={Queries.adminPromotionCategoryList} variables={{promotion_places: undefined}}>
                                    {queryResult => this.renderList(queryResult)}
                                </Query>
                            </div>
                        </div>
                    </div>
                </div>
            </Drawer>
        );
    }
}

export default compose(
    withRouter,
    injectIntl,
)(PromotionCategoryList);



// WEBPACK FOOTER //
// ./src/modules/PromotionCategory/pages/PromotionCategoryList.tsx